export const siteSettings = {
  name: "Sky Exchange Pro",
  link: "https://skyexpro.com",
  email: "support@skyexpro.com",
  appLink: "https://app.skyexpro.com",
};
